module.exports = (__webpack_require__("3MJi"))(12);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/object-assign/index.js from dll-reference AnnotationStudioVendors
// module id = W2+e
// module chunks = 0